(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
(function () {
        var s = document.currentScript.closest('[data-zegar]');
        if (!s) { return; }
        var cel = new Date(s.getAttribute('data-cel')).getTime();
        var serwer = Date.parse(s.getAttribute('data-teraz'));
        var start = performance.now();
        var baza = Number.isFinite(serwer) ? serwer : Date.now();
        function terazMs() { return baza + performance.now() - start; }
        var dataPL = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit' });
        var dataWyswietlana = new Intl.DateTimeFormat('pl-PL', { timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit' });
        var czasPL = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
        function czesciPL(ms) {
            var p = {};
            czasPL.formatToParts(new Date(ms)).forEach(function (czesc) { p[czesc.type] = Number(czesc.value); });
            return p;
        }
        function terminPL(dzien, h, m) {
            var docelowy = Date.UTC(dzien.getUTCFullYear(), dzien.getUTCMonth(), dzien.getUTCDate(), h, m), wynik = docelowy;
            // Dwie korekty uwzględniają zmianę offsetu przy przejściu czasu letniego.
            for (var krok = 0; krok < 2; krok++) {
                var p = czesciPL(wynik);
                wynik += docelowy - Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
            }
            return wynik;
        }
        // Polska odmiana: 1 -> godzina, 2-4 (poza 12-14) -> godziny, reszta -> godzin.
        var formy = {
            godzin: ['' + __pewniaki_inline_cfg[0] + '', '' + __pewniaki_inline_cfg[1] + '', '' + __pewniaki_inline_cfg[2] + ''],
            minut:  ['' + __pewniaki_inline_cfg[3] + '', '' + __pewniaki_inline_cfg[4] + '', '' + __pewniaki_inline_cfg[5] + ''],
            sekund: ['' + __pewniaki_inline_cfg[6] + '', '' + __pewniaki_inline_cfg[7] + '', '' + __pewniaki_inline_cfg[8] + '']
        };
        function odmiana(n, f) {
            n = Math.abs(n);
            if (n === 1) { return f[0]; }
            var d = n % 10, ss = n % 100;
            if (d >= 2 && d <= 4 && !(ss >= 12 && ss <= 14)) { return f[1]; }
            return f[2];
        }
        function ustaw(k, val, proc) {
            var box = s.querySelector('[data-pkolo="' + k + '"]');
            if (!box) { return; }
            var v = s.querySelector('[data-pval="' + k + '"]');
            if (v) { v.textContent = val; }
            var pod = s.querySelector('[data-podpis="' + k + '"]');
            if (pod && formy[k]) { pod.textContent = odmiana(val, formy[k]); }
            var p = Math.max(0, Math.min(100, proc));
            var prawa = box.querySelector('.pkolo__prawa .pkolo__bar');
            var lewa  = box.querySelector('.pkolo__lewa .pkolo__bar');
            if (prawa) { prawa.style.transform = 'rotate(' + (Math.min(p, 50) / 50 * 180) + 'deg)'; }
            if (lewa)  { lewa.style.transform  = 'rotate(' + (p > 50 ? (p - 50) / 50 * 180 : 0) + 'deg)'; }
        }
        // Godziny losowań dotyczą Warszawy także na telefonie w innej strefie.
        var godziny = (s.getAttribute('data-godziny') || '').split(',')
            .map(function (g) { return g.trim(); })
            .filter(function (g) { return /^\d{1,2}:\d{2}$/.test(g); });
        function przeliczCel() {
            if (!godziny.length || cel - terazMs() >= 0) { return; }
            var teraz = terazMs(), p = czesciPL(teraz), najblizszy = null;
            for (var dzien = 0; dzien <= 1; dzien++) {
                for (var i = 0; i < godziny.length; i++) {
                    var hm = godziny[i].split(':');
                    var k = terminPL(new Date(Date.UTC(p.year, p.month - 1, p.day + dzien)), parseInt(hm[0], 10), parseInt(hm[1], 10));
                    if (k > teraz && (najblizszy === null || k < najblizszy)) { najblizszy = k; }
                }
            }
            if (najblizszy !== null) { cel = najblizszy; }
        }
        function tik() {
            if (cel - terazMs() < 0) {
                przeliczCel();
            }
            var d = Math.max(0, Math.floor((cel - terazMs()) / 1000));
            var h = Math.floor(d / 3600), m = Math.floor((d % 3600) / 60), sec = d % 60;
            ustaw('godzin', h, (h % 24) / 24 * 100);
            ustaw('minut', m, m / 60 * 100);
            ustaw('sekund', sec, sec / 60 * 100);
            var kiedy = s.querySelector('[data-zegar-kiedy]');
            if (kiedy) { kiedy.textContent = dataPL.format(new Date(cel)) !== dataPL.format(new Date(terazMs())) ? '' + __pewniaki_inline_cfg[9] + '' : '' + __pewniaki_inline_cfg[10] + ''; }
            var data = s.querySelector('[data-zegar-data]');
            if (data) { data.textContent = dataWyswietlana.format(new Date(cel)); }
        }
        tik();
        setInterval(tik, 1000);
    })();
})();
